import React from 'react';
import { Badge } from 'reactstrap';

import { types } from '../shared/models/shippingRequest';

export default function ShippingRequestTypeBadge(props) {
  const { type = 'normal', ...extraProps } = props;
  const { label, color } = types[type];
  return (
    <Badge color={color} {...extraProps}>
      {label}
    </Badge>
  );
};
